angular.module('bmsApp.dashboard')
	.controller('TrainingModalCtrl', TrainingModalCtrl);

TrainingModalCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'userCourse',
	'$ngBootbox',
	'$modalInstance',
	'SharedTrainingSvc',
];

function TrainingModalCtrl(
	$scope,
	$state,
	$q,
	userCourse,
	$ngBootbox,
	$modalInstance,
	SharedTrainingSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		validator: {
			config: {},
			api: {}
		},
		options: {
		},
		datePickerConfig: angular.extend(angular.copy($scope.config.datePicker.basic), {
			options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
				parentEl: '.modal-content'
			}),
		}),
	});


	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.init = () => {
		self.userCourse = userCourse;
		angular.extend(self.userCourse, {
			due_at: moment(self.userCourse.due_at, 'YYYY-MM-DD HH:mm:s'),
		});
		self.loading = true;
	};

	handlers.cancel = () => {
		$modalInstance.dismiss('cancel');
	};

	handlers.updateDueAtClick = () => {
		SharedTrainingSvc.updateDueDate({
			id: self.userCourse.id,
			due_at: self.userCourse.due_at,
		}).then((response) => {
			$modalInstance.close({
				userCourse: self.userCourse,
				refresh: false,
			});
		});
	};

	handlers.setAsCompleteClick = () => {
		SharedTrainingSvc.setAsComplete({
			id: self.userCourse.id,
		}).then((response) => {
			self.userCourse.completed_at = moment();
			$modalInstance.close({
				userCourse: self.userCourse,
				refresh: true,
			});
		});
	};

	handlers.startRefresherClick = () => {
		SharedTrainingSvc.startRefresher({
			id: self.userCourse.id,
		}).then((response) => {
			self.userCourse.refresh_in_progress_at = moment();
			handlers.startCourseClick();
			$modalInstance.close({
				userCourse: self.userCourse,
				refresh: true,
			});
		});
	};

	handlers.startCourseClick = () => {
		window.open(window.config.app.nitro_url + 'learn/start');
	};

	handlers.toggleDisabled = () => {
		SharedTrainingSvc.toggleDisabled({
			id: self.userCourse.id,
		}).then((response) => {
			if (self.userCourse.disabled_at) {
				self.userCourse.disabled_at = null;
			}
			else {
				self.userCourse.disabled_at = moment();
			}
			$modalInstance.close({
				userCourse: self.userCourse,
				refresh: false,
			});
		});
	};

	handlers.submitClick = () => {
		// angular.extend(self.form, {
		// 	share: item.share,
		// });
		//
		// SharedTrainingSvc.saveShare(self.form).then((response) => {
		// 	self.shares.unshift(response.data.share);
		// });
	};
}
